import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import Replay from "@/pages/replay/page";
import Replays from "@/pages/replays/page";
import Team from "@/pages/team/page";
import Teams from "@/pages/teams/page";
import Player from "@/pages/player/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },
  {
    path: "/category/:season",
    element: (
      <Layout>
        <Category />
      </Layout>
    ),
  },
  {
    path: "/detail/:gameId",
    element: (
      <Layout>
        <Detail />
      </Layout>
    ),
  },
  {
    path: "/replay/:gameId",
    element: (
      <Layout>
        <Replay />
      </Layout>
    ),
  },
  {
    path: "/replays",
    element: (
      <Layout>
        <Replays />
      </Layout>
    ),
  },
  {
    path: "/team/:teamId",
    element: (
      <Layout>
        <Team />
      </Layout>
    ),
  },
  {
    path: "/teams",
    element: (
      <Layout>
        <Teams />
      </Layout>
    ),
  },
  {
    path: "/player/:playerId",
    element: (
      <Layout>
        <Player />
      </Layout>
    ),
  },
  {
    path: "/about",
    element: (
      <Layout>
        <About />
      </Layout>
    ),
  },
  {
    path: "*",
    element: (
      <Layout>
        <NotFound />
      </Layout>
    ),
  },
];

export default routes;